import type { IDashboardWidgetInterface } from "app/components/widget/utils/DashboardWidgetsInterfaces-v2";
import type { FC } from "react";
import { translate } from "app/filters/i18nFilter";
import styled from "styled-components";
import { SourceTypeMap } from "app/UtilitiesAndConstants/Constants/SourceTypes";

const Subtitle = styled.span`
    padding: 0 8px;
`;

export const LandingPagesTableSubtitle: FC<IDashboardWidgetInterface> = (props) => {
    const { widget } = props;
    const sourceType = widget._params.sourceType ?? SourceTypeMap.Organic;
    const tableTab = translate(`dashboard.website.keywords.custom.subtitle.sourceType.${sourceType}.title`);

    return (
        <Subtitle
            title={tableTab}
            className="swWidget-dashboard-subTitle-tableTab"
        >
            {tableTab}
        </Subtitle>
    );
};
